export default __webpack_public_path__ + "assets/images/995d16782fe8d8dd59ff1efcad1e0bf9.png";